var map = {
	"./workcase8Other1.jpg": 9694,
	"./workcase8Other2.jpg": 2777,
	"./workcase8Other3.jpg": 4732,
	"./workcase8Other4.jpg": 5927,
	"./workcase8Other5.jpg": 2090,
	"./workcase8Other6.jpg": 4693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8689;